import { Injectable, inject } from "@angular/core";

import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";

import { LorenNotification } from "../../../shared/services/loren-notification-service/interfaces/loren-notification.interface";
import { LorenNotificationResolverConstant } from "./constants/loren-notification-resolver.constants";
import { LorenNotificationService } from "../../../shared/services/loren-notification-service/loren-notification.service";

@Injectable({
  providedIn: "root",
})
export class LorenNotificationResolver implements Resolve<LorenNotification> {
  private lorenNotificationService = inject(LorenNotificationService);


  resolve(route: ActivatedRouteSnapshot): Observable<LorenNotification> {
    const id = route.params[LorenNotificationResolverConstant.NOTIFICATION];

    if (id) {
      return this.lorenNotificationService.getUserNotification(id);
    }
  }
}
